﻿$.fn.dxCtrlPagePlanitiReunionExterneChoix = function custom_dxCtrlPagePlanitiReunionExterneChoix(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpageplanitireunionexternechoix dx-ctrl");
        this.createInstance(new cdxCtrlPagePlanitiReunionExterneChoix(this, option));
    }
    return this;
}

window.cdxCtrlPagePlanitiReunionExterneChoix = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.reprogrammation == 'undefined') option.reprogrammation = false
    if (option.idPlanitiReunion == null || option.idPlanitiReunion == 0) delete option.idPlanitiReunion

    var $DivContainer = null
    var $DivDetail = null;
    var dxScrollDate = null
    var dxScrollDateElement = null
    var dxScrollDateContent = null
    var jauge = null
    function mConstruit() {
        container.empty();
        dxScrollDate = null
        dxDateHeure = null
        //container.css("position", "relative")
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        //if (option.dataPlaniti.planiti.ferme == "1" && typeof option.idPlanitiReunion != 'undefined') {
        //    $DivContainer = $("<div style='width:calc(100% - 100px);padding:50px;margin:50px;text-align:center;border:" + theme.border + ";height:calc(100% - 100px);' class='dx-theme-border-color-as-background-color'>Bonjour,<br/>Cette évènement ne propose plus de créneaux.</div>").appendTo(container)
        //} else {
        $DivContainer = $("<div style='width:calc(100% - 100px);max-width:1200px;height:calc(100% - 100px);margin:50px;border:" + theme.border + ";display:flex;' class='dx-theme-border-color-as-background-color'/>").appendTo(container)
        var $DivContainerInner = $("<div style='position:relative;width:100%;'/>").appendTo($DivContainer)
        $DivDetail = $("<div style='position:absolute;width:35%;left:0;top:0;word-break:break-word;min-height:500px;padding:25px;'/>").appendTo($DivContainerInner)
        resizeObserver.mAdd($DivDetail, function () {
            mResize()
        })
        if (!parametre.isPhone) {
            dxScrollDate = $("<div style='position:absolute;width:65%;left:35%;top:0;border-left:" + theme.border + ";text-align:center;padding:25px;'/>").appendTo($DivContainerInner).dxScrollView({}).dxScrollView("instance")
            dxScrollDateElement = dxScrollDate.element()
            dxScrollDateContent = dxScrollDate.content()
        } else {
            dxScrollDateElement = $("<div style='position:absolute;width:65%;left:35%;top:0;border-left:" + theme.border + ";text-align:center;padding:10px;'/>").appendTo($DivContainerInner)
            dxScrollDateContent = dxScrollDateElement
        }

        //$DivDate = $("<div style='position:absolute;width:60%;left:40%;top:0;border-left:" + theme.border + ";text-align:center;min-height:500px;padding:25px;'/>").appendTo(dxScroll.content())
        resizeObserver.mAdd($DivContainer, function () {
            mResize()
        })
        if (option.dataPlaniti.planiti == null) {
            $("<div style='font-size:200%'>Cette évènement n'existe plus.</div>").appendTo(dxScrollDateContent)
        } else {
            mRempliDetail()
            mResize()
            if (typeof option.idPlanitiReunion == 'undefined' || option.idPlanitiReunion == null || option.idPlanitiReunion == 0 || option.reprogrammation) {
                if (option.dataPlaniti.planiti.ferme == "1") {
                    $("<div>Cette évènement ne propose plus de créneaux.</div>").appendTo(dxScrollDateContent)
                } else {
                    mRempliDateHeure()
                }
            } else {
                if (option.annulation) {
                    mRempliAnnulation()
                } else {
                    mRempliPageFinalReunion(false, false, false)
                }
            }
        }
        //}
        if (parametre.isPhone) $DivContainer.css({
            margin: "0",
            padding: "10px",
            width: "100%",
            height: ""
        })
    }

    function mResize() {
        if ($DivContainer.innerWidth() < 750) {
            $DivDetail.css({
                "width": "100%",
                "left": "0",
                "top": "0",
                "text-align": "center",
                "min-height": ""
            })
            dxScrollDateElement.css({
                "width": "100%",
                "left": "0",
                "top": $DivDetail.innerHeight() + "px",
                "height": "calc(100% - " + $DivDetail.innerHeight() + "px)",
                "border-left": "none",
                padding: "0 25px 25px 25px"
            })
            $TdDateDetailLeft.show()
            $TdDateDetailReprogrammeLeft.show()
        } else {
            $DivDetail.css({
                "width": "35%",
                "left": "0",
                "top": "0",
                "text-align": "left"
            })
            dxScrollDateElement.css({
                "width": "65%",
                "left": "35%",
                "height": "100%",
                "top": "0",
                "border-left": theme.border,
                padding: "25px"
                //"min-height": "500px"
            })
            $TdDateDetailLeft.hide()
            $TdDateDetailReprogrammeLeft.hide()
        }
        if (parametre.isPhone) {
            $DivContainer.css("height", "100%")
            dxScrollDateElement.css("height", "")
            dxScrollDateElement.css("padding", "0 3px 3px 3px")
            $DivDetail.css("position", "")
            dxScrollDateElement.css("position", "")
            $DivContainer.css("overflow", "auto")
        }
    }

    var $DivDateDetail = null
    var $TdDateDetailLeft = null
    var $TdDateDetailLib = null
    var $DivDateDetailReprogramme = null
    var $TdDateDetailReprogrammeLeft = null
    var $TdDateDetailReprogrammeLib = null
    var $DivReprogramme = null
    var $DivAnnulation = null
    function mRempliDetail() {
        $DivDetail.empty()
        var $DivImg = $("<div style='background-color:" + theme.color.replace("rgb(", "rgba(").replace(")", ",0.2)") + ";display:inline-block;padding:5px;border-radius:20%;margin-bottom:10px;'/>").appendTo($DivDetail)

        var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo($DivImg).dxCtrlImageData({
            bddCtrl: option.bddCtrl,
            size: 60,
            data: option.dataPlaniti.planiti,
            showTextOnImage: false,
            showText: false,
            fontSizeText: "30px",
            allowDisplayIcone: true,
            allowClick: false,
            srcImgDefaut: parametre.baseAppli.img_logo
        }).dxCtrlImageData("instance");

        //$("<img src='" + parametre.img + "' style='width:60px;'/>").appendTo($DivImg)
        $("<div style='font-size:160%;font-weight:bold;'>" + option.dataPlaniti.planiti.nom + "</div>").appendTo($DivDetail)

        $("<div style='padding:5px 0;font-size:160%;font-weight:bold;'><i class='fas fa-clock-rotate-left fa-flip-horizontal dx-theme-accent-as-text-color'></i> <span style='opacity:0.3'>" + option.dataPlaniti.planiti.duree_reunion_mn + " minutes</span></div>").appendTo($DivDetail)

        $("<div style='padding:5px 0;font-size:90%;font-style:italic;opacity:0.3;'>" + option.dataPlaniti.planiti.description + "</div>").appendTo($DivDetail)

        if (option.reprogrammation) {
            $DivReprogramme = $("<div style='padding:5px 0;font-size:160%;font-wieght:bold;' class='dx-theme-accent-as-text-color'><b>Reprogrammer</b> une réunion</div>").appendTo($DivDetail)
        }
        if (option.annulation) {
            $DivAnnulation = $("<div style='padding:5px 0;font-size:160%;font-wieght:bold;' class='dx-theme-accent-as-text-color'><b>Annuler</b> une réunion</div>").appendTo($DivDetail)
        }

        $DivDateDetail = $("<div style='padding:5px 0;display:none;" + ((option.reprogrammation) ? "text-decoration:line-through;" : "") + "'/>").appendTo($DivDetail)
        var $TableDateDetail = $("<table/>").appendTo($DivDateDetail)
        var $Tr = $("<tr/>").appendTo($TableDateDetail)
        $TdDateDetailLeft = $("<td style='width:50%;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;font-size:160%;padding-right:5px;'><i class='fas fa-calendar-check dx-theme-accent-as-text-color'></i></td>").appendTo($Tr)
        $TdDateDetailLib = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var $Td = $("<td style='width:50%;'/>").appendTo($Tr)

        $DivDateDetailReprogramme = $("<div style='padding:5px 0;display:none;'/>").appendTo($DivDetail)
        var $TableDateDetail = $("<table/>").appendTo($DivDateDetailReprogramme)
        var $Tr = $("<tr/>").appendTo($TableDateDetail)
        $TdDateDetailReprogrammeLeft = $("<td style='width:50%;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;font-size:160%;padding-right:5px;'><i class='fas fa-calendar-check dx-theme-accent-as-text-color'></i></td>").appendTo($Tr)
        $TdDateDetailReprogrammeLib = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
    }

    var dxDateHeure = null;
    var dateDebutOrigineReprogrammationAnnulation = null
    var dateFinOrigineReprogrammationAnnulation = null
    function mRempliDateHeure() {
        jauge.mShow()
        option.bddCtrl.mAjaxCall({ command: "getdateheureplaniti", id_planiti: option.dataPlaniti.planiti.id_planiti, id_planiti_reunion: option.idPlanitiReunion }, function (data) {
            if (typeof data.lstdate == 'undefined') data.lstdate = []
            data.lstdate.forEach(function (dat, idx) {
                data.lstdate[idx] = new Date(dat.split("|")[0], dat.split("|")[1]-1, dat.split("|")[2], dat.split("|")[3], dat.split("|")[4], dat.split("|")[5])
            })

            if (typeof option.idPlanitiReunion != "undefined") {
                //on est dans une reprogrammation ou une annulation
                //on affiche l'ancienne date
                dateDebutOrigineReprogrammationAnnulation = data.date_debut
                dateFinOrigineReprogrammationAnnulation = data.date_fin
                //data.date_debut = data.date_debut
                //data.date_fin = data.date_fin
                $TdDateDetailLib.html("Rendez-vous le<br/><b>" + DevExpress.localization.formatDate(dateDebutOrigineReprogrammationAnnulation, "eeee d MMMM yyyy") + "</b><br/>de <b>" + DevExpress.localization.formatDate(dateDebutOrigineReprogrammationAnnulation, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate(dateFinOrigineReprogrammationAnnulation, "HH:mm") + "</b>")
                $DivDateDetail.slideDown(300)
            }

            if (data.lstdate.length == 0) {
                $("<div>Aucun créneaux disponible pour cette évènement.</div>").appendTo(dxScrollDateContent)
                if (dxDateHeure) dxDateHeure.element.remove()
                dxDateHeure = null
            } else {
                if (dxDateHeure == null) {
                    dxDateHeure = $("<div/>").appendTo(dxScrollDateContent).dxCtrlPlanitiDateHeure({
                        isInterne: option.isInterne,
                        bddCtrl: option.bddCtrl,
                        dxScroll: dxScrollDate,
                        lstDate: data.lstdate,
                        onClickDate: function (dat) {
                            if (option.reprogrammation) {
                                mRempliReprogrammation(dat)
                            } else {
                                mRempliSaisieReunion(dat)
                            }

                        }
                    }).dxCtrlPlanitiDateHeure("instance")
                } else {
                    dxDateHeure.option("lstDate", data.lstdate)
                    dxDateHeure.mReload()
                }
            }

            jauge.mHide()
        })

    }

    var dxSaisieReunion = null
    function mRempliSaisieReunion(dat) {
        $TdDateDetailLib.html("Rendez-vous le<br/><b>" + DevExpress.localization.formatDate(dat, "eeee d MMMM yyyy") + "</b><br/>de <b>" + DevExpress.localization.formatDate(dat, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate((new Date(dat)).addMinutes(option.dataPlaniti.planiti.duree_reunion_mn), "HH:mm") + "</b>")
        $DivDateDetail.slideDown(300)

        dxDateHeure.element().fadeOut(200)
        if (dxSaisieReunion == null) {
            dxSaisieReunion = $("<div/>").appendTo(dxScrollDateContent).dxCtrlPagePlanitiReunionExterneChoixSaisie({
                jauge: jauge,
                bddCtrl: option.bddCtrl,
                dxScroll: dxScrollDate,
                dat: dat,
                dataPlaniti: option.dataPlaniti,
                onCancel: function () {
                    dxSaisieReunion.element().fadeOut(200)
                    dxDateHeure.element().fadeIn(200)
                    $DivDateDetail.slideUp(300, function () { })
                },
                onValidateReunion: function (idPlanitiReunion, idPlanitiReunionOrga) {
                    option.idPlanitiReunion = idPlanitiReunion
                    option.idPlanitiReunionOrga = idPlanitiReunionOrga
                    mRempliPageFinalReunion(true, false, false)
                }
            }).dxCtrlPagePlanitiReunionExterneChoixSaisie("instance")
            if (dxScrollDate) window.setTimeout(function () { dxScrollDate.update() }, 250)
            if (dxScrollDate) dxScrollDate.scrollTo(0)
        } else {
            dxSaisieReunion.option("dat", dat)
            dxSaisieReunion.element().fadeIn(200)
        }

    }

    var dxSaisieReprogrammation = null
    function mRempliReprogrammation(dat) {
        $TdDateDetailReprogrammeLib.html("Nouveau Rendez-vous le<br/><b>" + DevExpress.localization.formatDate(dat, "eeee d MMMM yyyy") + "</b><br/>de <b>" + DevExpress.localization.formatDate(dat, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate((new Date(dat)).addMinutes(option.dataPlaniti.planiti.duree_reunion_mn), "HH:mm") + "</b>")
        $DivDateDetailReprogramme.slideDown(300)

        dxDateHeure.element().fadeOut(200)
        if (dxSaisieReprogrammation == null) {
            jauge.mShow()
            dxSaisieReprogrammation = $("<div/>").appendTo(dxScrollDateContent).dxCtrlPagePlanitiReunionExterneChoixReprogrammation({
                bddCtrl: option.bddCtrl,
                jauge: jauge,
                dat: dat,
                dateDebutOrigineReprogrammation: dateDebutOrigineReprogrammationAnnulation,
                dateFinOrigineReprogrammation: dateFinOrigineReprogrammationAnnulation,
                dataPlaniti: option.dataPlaniti,
                idPlanitiReunion: option.idPlanitiReunion,
                idPlanitiReunionOrga: option.idPlanitiReunionOrga,
                onCancel: function () {
                    dxSaisieReprogrammation.element().fadeOut(200)
                    dxDateHeure.element().fadeIn(200)
                    $DivDateDetailReprogramme.slideUp(300, function () { })
                },
                onValidateReprogrammation: function (idPlanitiReunion, dateDebut, dateFin) {
                    //option.reprogrammation = false
                    //mConstruit()
                    //dxFinalReunion.element().remove()
                    //dxFinalReunion = null
                    //mRempliPageFinalReunion(false, false, true)
                    dxSaisieReprogrammation.element().remove()
                    $TdDateDetailLib.html("Rendez-vous le<br/><b>" + DevExpress.localization.formatDate(dateDebut, "eeee d MMMM yyyy") + "</b><br/>de <b>" + DevExpress.localization.formatDate(dateDebut, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate(dateFin, "HH:mm") + "</b>")
                    $DivDateDetail.css("text-decoration", "")
                    $DivDateDetail.slideDown(300)
                    $DivReprogramme.remove()
                    dateDebutOrigineReprogrammationAnnulation = null
                    dateFinOrigineReprogrammationAnnulation = null
                    option.reprogrammation = false
                    $DivDateDetailReprogramme.slideUp()
                    mRempliPageFinalReunion(false, false, true)
                },
                onContentReady: function (e) {
                    jauge.mHide()
                }
            }).dxCtrlPagePlanitiReunionExterneChoixReprogrammation("instance")
            if (dxScrollDate) window.setTimeout(function () { dxScrollDate.update() }, 250)
        } else {
            dxSaisieReprogrammation.option("dat", dat)
            dxSaisieReprogrammation.element().fadeIn(200)
        }
    }

    var dxSaisieAnnulation = null
    function mRempliAnnulation() {
        $TdDateDetailLib.html("Rendez-vous le<br/><b>" + DevExpress.localization.formatDate(dateDebutOrigineReprogrammationAnnulation, "eeee d MMMM yyyy") + "</b><br/>de <b>" + DevExpress.localization.formatDate(dateDebutOrigineReprogrammationAnnulation, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate(dateFinOrigineReprogrammationAnnulation, "HH:mm") + "</b>")
        $DivDateDetail.slideDown(300)

        if (dxSaisieAnnulation == null) {
            dxSaisieAnnulation = $("<div/>").appendTo(dxScrollDateContent).dxCtrlPagePlanitiReunionExterneChoixAnnulation({
                bddCtrl: option.bddCtrl,
                dataPlaniti: option.dataPlaniti,
                idPlanitiReunion: option.idPlanitiReunion,
                idPlanitiReunionOrga: option.idPlanitiReunionOrga,
                dateDebutOrigineAnnulation: dateDebutOrigineReprogrammationAnnulation,
                dateFinOrigineAnnulation: dateFinOrigineReprogrammationAnnulation,
                onValidateAnnulation: function (idPlanitiReunion) {
                    //option.reprogrammation = false
                    //mConstruit()
                    //dxFinalReunion.element().remove()
                    //dxFinalReunion = null
                    //mRempliPageFinalReunion(false, false, true)
                    ////option.annulation = false
                    ////mConstruit()
                    dxSaisieAnnulation.element().remove()
                    $DivAnnulation.remove()
                    $DivDateDetail.css("text-decoration", "line-through")
                    mRempliPageFinalReunion(false, true, false)
                }
            }).dxCtrlPagePlanitiReunionExterneChoixAnnulation("instance")
            if (dxScrollDate) window.setTimeout(function () { dxScrollDate.update() }, 250)
        } else {
            dxSaisieAnnulation.element().fadeIn(200)
        }
    }

    var dxFinalReunion = null
    function mRempliPageFinalReunion(creation, annulation, reprogrammation) {
        if (dxSaisieReunion) dxSaisieReunion.element().fadeOut(200)
        dxFinalReunion = $("<div/>").appendTo(dxScrollDateContent).dxCtrlPagePlanitiReunionExterneFinal({
            bddCtrl: option.bddCtrl,
            dataPlaniti: option.dataPlaniti,
            idPlanitiReunion: option.idPlanitiReunion,
            idPlanitiReunionOrga: option.idPlanitiReunionOrga,
            creation: creation,
            reprogrammation: reprogrammation,
            annulation: annulation,
            onDemandeAnnulation: function () {
                option.annulation = true
                mConstruit()
            },
            onDemandeReprogrammation: function () {
                option.reprogrammation = true
                mConstruit()
            },
            onContentReady: function (e) {
                $TdDateDetailLib.html("Rendez-vous le<br/><b>" + DevExpress.localization.formatDate(e.component.getDateDebut(), "eeee d MMMM yyyy") + "</b><br/>de <b>" + DevExpress.localization.formatDate(e.component.getDateDebut(), "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate(e.component.getDateFin(), "HH:mm") + "</b>")
                $DivDateDetail.slideDown(300)
                dateDebutOrigineReprogrammationAnnulation = e.component.getDateDebut()
                dateFinOrigineReprogrammationAnnulation = e.component.getDateFin()
            }
        }).dxCtrlPagePlanitiReunionExterneFinal("instance")
    }

    this.mUpdate = function () {
        mRempli()
    }

    this.mUpdateDetail = function () {
        //mRempliDetail()
        mConstruit()
    }

    this.mUpdateHeure = function () {
        //mRempliDateHeure()
        mConstruit()
    }

    this.element = function () { return container; }

    mConstruit();
}